import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller, set } from "react-hook-form";
import SelectBox from "../../../components/elements/form/selectBox";
import { Option } from "../../../_config/types";
import Datepicker from "../../../components/elements/form/datepicker";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import toast from "react-hot-toast";
import { useFacilityManagersSelector } from "../../../store/selectors/masterSelector";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import moment, { Moment } from "moment";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import { getSelectedOption, getSelectedOptions } from "../../../_common/functions";
import Teaxtarea from "../../../components/elements/form/textarea";
import Loader from "../../../components/loader";

interface AssetsFormProps {
  _ref?: any;
  editData?: any;
  currentStatus?: any;
  isAssignonly?: boolean;
  onCreate?: () => void;
  onCancel?: () => void;
}

type CreateWorkOrderFormValueType = {
  workOrderID: any;
  workRequestCode: string;
  workOrderCode: string;
  workOrderStatusID: any;
  startDate: Date | null;
  startTime: Option | undefined;
  endDate: Date | null;
  endTime: Option | undefined;
  originalStartDate: Date | null;
  originalStartTime: Option | undefined;
  originalEndDate: Date | null;
  originalEndTime: Option | undefined;
  workRequestPriorityID: any;

  assignmentTypeID: any;
  technicialID: any;
  woGrowerID: 0;
  woVendorID: 0;
  woUserMapping: [
    {
      userID: 0;
    }
  ];
  woAssetMapping: [{ assetID: 0 }];
  woSpareParts: [
    {
      sparePartID: 0;
      requiredQty: 0;
      facilityID: 0;
      subFaclityID: 0;
    }
  ];
  Notes: string;
  assetImage: any;
};

const ScheduleModalWorkOrder: React.FC<AssetsFormProps> = ({ _ref, editData, currentStatus, isAssignonly = false, onCreate = () => { }, onCancel = () => { } }) => {
  const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues, } = useForm<CreateWorkOrderFormValueType>({
    defaultValues: {
      workOrderStatusID: 2,
    },
  });

  const hasEditRun = useRef(false);
  const isInitialLoad = useRef(false);

  const { showLoader, hideLoader } = useAppLoader();

  const [assigntypeList, setAssigntypeList] = useState<any>(null);
  const [userList, setUserList] = useState<any>(null);
  const [isMultiTechnicial, setIsMultiTechnicial] = useState<boolean>(false);
  const [technicianlabel] = useState<string>(`Assigned User`);
  const [ woloader, setWoloader ] = useState<boolean>(false);

  const assigntypeWatcher = watch("assignmentTypeID");
  const technicianWatcher = watch("technicialID");
  const startdateWatch = watch("startDate");
  const starttimeWatch = watch("startTime");
  const commonApi: any = useCommonApi();
  const workOrderAPI: any = useWorkOrderApi();

  const users: any = useFacilityManagersSelector();

  // Generate time options in 15-minute intervals
  const generateTimeOptions = () => {
    const times: Option[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = moment().hour(hour).minute(minute).second(0).millisecond(0);
        times.push({
          label: time.format('hh:mm A'),
          value: time.format('HH:mm:ss'),
          data: time
        });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  // Function to add 15 minutes to a given time option
  const addFifteenMinutes = (timeOption: any) => {
    if (!timeOption) return timeOptions[0];
    const currentTime = moment(timeOption.value as string, 'HH:mm:ss');
    const newTime = currentTime.add(15, 'minutes');
    const timeStr = newTime.format('HH:mm:ss');
    return timeOptions.find((opt: Option) => opt && opt.value === timeStr) || timeOptions[0];
  };

  /* const GetTechnicianList = async() => {
    return new Promise((resolve, reject) => {
      commonApi.GetUserList({}, (resp: any) => {
        if (resp.hasOwnProperty(`userList`) && Array.isArray(resp.userList) && resp.userList.length > 0) {
          const userList = resp.userList.map((user: any) => {
            return {
              label: user.firstName + " " + user.lastName,
              value: user.userID,
            };
          });          
          setUserList(userList);
          resolve(userList);
        } else {          
          setUserList([]);
          resolve([]);
        }
      }, (error: any) => {
          setUserList([]);
          reject([])
          toast.error(error);
      });
    });
  }; */

  const GetTechnicianList = (userType:number, callback?: (list: any[]) => void) => {
    console.log("Technician List API called", { userType });
    commonApi.GetUserList({
      userTypeID:userType
    }, (resp: any) => {
      let deptlist: any = [];
      //console.log("resp", resp);
      resp.userList?.map((user: any) => {
        deptlist.push({
          label: user.firstName + " " + user.lastName,
          value: user.userID,
        });
      });
      console.log("User list loaded", { userType, deptlist });
      setUserList(deptlist);
      if (callback) {
        callback(deptlist);
      }
    }, (error: any) => {
      console.log("error =>", error);
      setUserList([]);
      if (callback) {
        callback([]);
      }
      //toast.error(error);
    });
  };
  
  const GetAssignmentTypeList = async () => {
    return new Promise((resolve, reject) => {
      workOrderAPI.GetWOAssignmentTypeList({}, (resp: any) => {
        if (resp && resp.hasOwnProperty(`workOrderAssignmentTypeList`) && Array.isArray(resp.workOrderAssignmentTypeList) && resp.workOrderAssignmentTypeList.length > 0) {
          const assignlist = resp.workOrderAssignmentTypeList.map((assignmentType: any) => {
            return {
              label: assignmentType.woAssignmentTypeName,
              value: assignmentType.woAssignmentTypeID,
            };
          });
          setAssigntypeList(assignlist);
          resolve(assignlist);
        } else {
          setAssigntypeList([]);
          resolve([]);
        }
      }, (error: any) => {
          toast.error(error);
          reject([]);
      });
    });
  };  

  const GetVendorList = async () => {
    return new Promise((resolve, reject) => {
      commonApi.GetServiceprovidertList({}, (resp: any) => {
        if (resp && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
          const vendorList = resp.vendorList.map((vendor: any) => {
            return {
              label: vendor.name,
              value: vendor.vendorID,
            };
          });   
          setUserList(vendorList);
          resolve(vendorList);
        } else {
          setUserList([]);
          resolve([]);          
        }
      }, (error: any) => {
        toast.error(error);
        setUserList([]);
        reject([]);
      });
    });
  };

  const formReset = async () => {
    setValue("startDate", null);
    setValue("endDate", null);
    setValue("startTime", null);
    setValue("endTime", null);
    setValue("assignmentTypeID", null);
    setValue("technicialID", null);
    setValue("workOrderStatusID", 2);
    hasEditRun.current = false; // Reset the flag so form can be populated again
    isInitialLoad.current = false; // Reset initial load flag
    /*
    reset({
      startDate: null,
      endDate: null,
      workOrderStatusID: 2
    });
    */
  };

  const init_page_date = async () => {
    setWoloader(true);
    await GetAssignmentTypeList().catch(() => { return [] });
    // default load using first assignment type value
    GetTechnicianList(1);
    setWoloader(false);
  }

  const onSubmit: SubmitHandler<CreateWorkOrderFormValueType> = (data: any) => {
    //  const AssData = selectedAssets.map((node: any) => node.assetID);
    var payload: any = {
      workOrderID: null,
      startDate: null,
      endDate: null,
      assignmentTypeID: null,
      departmentID: editData?.departmentID || null,
      woGrowerID: null,
      woVendorID: null,
      woUserMapping: [],
      WorkOrderStatusID: currentStatus || 2, // Default to 2 if not provided
      Notes: ``,
    };
    for (const index in Object.keys(payload)) {
      var key = Object.keys(payload)[index];
      if (key in data) {
        payload[key] = data[key];
      }
    }
    const buildWoUserMapping = (technicians: any) => {
      if (!technicians) return [];
      const technicianArr = Array.isArray(technicians) ? technicians : [technicians];
      return technicianArr.map((item: any) => ({ userID: item.value }));
    };
    const firstTechnician = Array.isArray(data.technicialID)
      ? data.technicialID[0]
      : data.technicialID;
    
    if (typeof data.assignmentTypeID === "object") {
      payload.woUserMapping = buildWoUserMapping(data.technicialID);
      switch (data.assignmentTypeID.value.toString()) {
        case "1": {
          payload.woVendorID = null;
          payload.woGrowerID = null;
          break;
        }
        case "2": {
          payload.woGrowerID = firstTechnician?.value ?? null;
          payload.woVendorID = null;
          break;
        }
        case "3": {
          payload.woVendorID = firstTechnician?.value ?? null;
          payload.woGrowerID = null;
          break;
        }
      }
      payload.assignmentTypeID = data.assignmentTypeID.value;
    }

    if (data.workRequestPriorityID && typeof data.workRequestPriorityID === "object") {
      payload.workRequestPriorityID = data.workRequestPriorityID.value;
    }
    if (data.workOrderStatusID && typeof data.workOrderStatusID === "object") {
      payload.workOrderStatusID = data.workOrderStatusID.value;
    }
    if (data.startDate && data.startTime) {
      const timeValue = typeof data.startTime === "object" && data.startTime.value ? data.startTime.value : data.startTime;
      payload.startDate = moment(moment(data.startDate).format(`YYYY-MM-DD`) + " " + timeValue, `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
    } else {
      payload.startDate = null;
    }
    if (data.endDate && data.endTime) {
      const timeValue = typeof data.endTime === "object" && data.endTime.value ? data.endTime.value : data.endTime;
      payload.endDate = moment(moment(data.endDate).format(`YYYY-MM-DD`) + " " + timeValue, `YYYY-MM-DD HH:mm:ss`).utc().toISOString();
    } else {
      payload.endDate = null;
    }
    payload.workOrderID = editData ? editData?.workOrderID : null;
    payload.WorkOrderStatusID = currentStatus;
    if (moment.utc(payload.endDate).diff(moment.utc(payload.startDate), "minutes") < 1) {
      return toast.error("End date and time must be greater than start date and time.");
    }
    console.log("data is -> ", data);
    console.log("payload is-> ", payload);
    //return false;

    showLoader();
    workOrderAPI.UpdateWorkOrderSchedule(payload, (resp: any) => {
      onCreate();      
      //onCancel();
      console.log(resp, "Submited resp");
      toast.success(resp?.message);
      formReset();
      hasEditRun.current = false;
      hideLoader();
    }, (error: any) => {
      console.log("error =>", error);
      hideLoader();
      hasEditRun.current = false;
      toast.error(error);
    });
    console.log("Submit payload", payload);
  };  

  useEffect(() => {
    init_page_date();
  }, []);  

  useEffect(() => {
    if (editData && users && assigntypeList && userList && !hasEditRun.current) {
      const innerfunc = async () => {
        setWoloader(true);
        console.log("editData", editData);        
        setValue("assignmentTypeID", editData.woAssignmentTypeID ? { label: editData.woAssignmentTypeName, value: editData.woAssignmentTypeID } : null);
        
        // Handle dropped dates and times if available
        if (editData.newDropStartDate && editData.newDropStartTime) {
          setValue("startDate", new Date(editData.newDropStartDate));
          const startTimeStr = typeof editData.newDropStartTime === 'string' ? editData.newDropStartTime : moment(editData.newDropStartTime).format('HH:mm:ss');
          const startTimeOption = timeOptions.find((opt: Option) => opt && opt.value === startTimeStr);
          setValue("startTime", startTimeOption);
        } else if (editData.startDate) {
          setValue("startDate", new Date(moment.utc(editData.startDate).local().format('YYYY-MM-DD')));
          const startTimeMoment = moment.utc(editData.startDate).local();
          const startTimeOption = timeOptions.find((opt: Option) => opt && opt.value === startTimeMoment.format('HH:mm:ss'));
          setValue("startTime", startTimeOption);
        }
        
        if (editData.newDropEndDate && editData.newDropEndTime) {
          setValue("endDate", new Date(editData.newDropEndDate));
          const endTimeStr = typeof editData.newDropEndTime === 'string' ? editData.newDropEndTime : moment(editData.newDropEndTime).format('HH:mm:ss');
          const endTimeOption = timeOptions.find((opt: Option) => opt && opt.value === endTimeStr);
          setValue("endTime", endTimeOption);
        } else if (editData.endDate) {
          setValue("endDate", new Date(moment.utc(editData.endDate).local().format('YYYY-MM-DD')));
          const endTimeMoment = moment.utc(editData.endDate).local();
          const endTimeOption = timeOptions.find((opt: Option) => opt && opt.value === endTimeMoment.format('HH:mm:ss'));
          setValue("endTime", endTimeOption);
        }
        
        switch (editData.woAssignmentTypeID) {
          case 2:
            setIsMultiTechnicial(false);
            await new Promise<void>((resolve) => {
              GetTechnicianList(editData.woAssignmentTypeID, (growerList) => {
                if (editData?.woGrowerID && growerList && growerList.length > 0) {
                  const selectedGrower = getSelectedOption(editData.woGrowerID, growerList);
                  console.log("Setting grower", { growerID: editData.woGrowerID, selectedGrower, growerList });
                  setValue("technicialID", selectedGrower);
                }
                resolve();
              });
            });
            break;
          case 3:
            setIsMultiTechnicial(false);
            await new Promise<void>((resolve) => {
              GetTechnicianList(editData.woAssignmentTypeID, (vendorList) => {
                if (editData?.woVendorID && vendorList && vendorList.length > 0) {
                  const selectedVendor = getSelectedOption(editData.woVendorID, vendorList);
                  console.log("Setting vendor", { vendorID: editData.woVendorID, selectedVendor, vendorList });
                  setValue("technicialID", selectedVendor);
                }
                resolve();
              });
            });
            break;
          default:
            // For all other assignment types (1 = Internal, 5 = Accounting, etc.)
            setIsMultiTechnicial(true);
            await new Promise<void>((resolve) => {
              GetTechnicianList(editData.woAssignmentTypeID, (userListData) => {
                if (editData.hasOwnProperty(`workOrderUserMappingList`) && Array.isArray(editData.workOrderUserMappingList) && editData.workOrderUserMappingList.length > 0 && userListData && userListData.length > 0) {
                  const userIDs = editData.workOrderUserMappingList.map((o: any) => o.userID);
                  const selectedUsers = getSelectedOptions(userIDs, userListData);
                  console.log("Setting users", { assignmentType: editData.woAssignmentTypeID, userIDs, selectedUsers, userListData });
                  setValue("technicialID", selectedUsers);
                }
                resolve();
              });
            });
            break;
        } 
        hasEditRun.current = true;
        // Set initial load complete after a small delay to allow form to settle
        setTimeout(() => {
          isInitialLoad.current = true;
        }, 500);
        setWoloader(false);   
      };
      innerfunc();
    } else {
      if (!hasEditRun.current) {
        formReset();
      } else {
        // If no editData but hasEditRun is true, allow auto-update
        isInitialLoad.current = true;
      }
    }      
  }, [ editData, users, assigntypeList, userList ]);

  // Auto-update end time when start time changes
  useEffect(() => {
    if (starttimeWatch && isInitialLoad.current) {
      const newEndTime = addFifteenMinutes(starttimeWatch);
      setValue("endTime", newEndTime);
    }
  }, [starttimeWatch]);

  // Auto-update end date when start date changes
  useEffect(() => {
    if (startdateWatch && isInitialLoad.current) {
      setValue("endDate", startdateWatch);
    }
  }, [startdateWatch]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reset = formReset;
    }
  }, [_ref]);

  return (
    <div className={ `relative` }>
      {woloader && (
        <div className={ `absolute p-8` } style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={ `${woloader? `hidden`: `flex`} flex-col`} >
        <div className="flex-1 overflow-auto" style={{ minHeight: `calc(100vh - 152px)` }}>

          <h4 className="font-semibold text-[0.938rem] border-gray-200 py-4 uppercase" style={{ color: "#000000", fontSize: 15 }}>General</h4>

          {editData?.workOrderCode && (
            <div className={""} style={{ background: `#5FBA6117`, padding: 10, borderRadius: 5 }}>
              <h6 className="font-semibold uppercase" style={{ color: `#000`, fontSize: 14 }}>{editData?.workOrderCode}</h6>
              <p className="font-normal mt-2 line-clamp-3" style={{ color: `#323233`, fontSize: 15 }}>{editData?.description}</p>
            </div>
          )}

          <div className={`h-[0.5rem]`}></div>

          <div>
            <div className="flex justify-between my-4 pb-0">
              <div className={`font-semibold`} style={{ fontSize: 15 }}>ASSIGNEE</div>
            </div>

            <Controller
              name="assignmentTypeID"
              control={control}
              rules={{ required: "Assignment Type is required" }}
              render={({ field: { value, onChange } }) => (
                <SelectBox
                  label="Assignment Type"
                  value={value}
                  onChange={async (SelectOption: any) => {
                    onChange(SelectOption);
                    setValue("technicialID", null);
                    setIsMultiTechnicial(SelectOption?.value === 1);
                    if (SelectOption) {
                      await GetTechnicianList(SelectOption.value);
                    }
                    //if (SelectOption?.value !== 1) {
                    //  setValue("technicialID", null);
                  //}
                  }}
                  required
                  placeholder="Assignment Type"
                  options={assigntypeList? assigntypeList : []}
                  error={errors.assignmentTypeID?.message as any}
                />
              )}
            />

            <Controller
              name="technicialID"
              control={control}
              rules={{ required: "This is required" }}
              render={({ field: { value, onChange } }) => (
                <SelectBox
                  label={technicianlabel}
                  isMulti={isMultiTechnicial}
                  value={value}
                  onChange={onChange}
                  required
                  placeholder="Select Option"
                  options={userList ? userList : []}
                  error={errors.technicialID?.message as any}
                />
              )}
            />
          </div>

          <div className={``}>
            <div className={`flex justify-between mt-8 mb-0 pb-0`}>
              <div className={`font-semibold`} style={{ fontSize: 15 }}>SCHEDULED</div>
            </div>
            <div className={`grid grid-cols-2 gap-2 relative ${isAssignonly ? `disabled-x` : ``}`}>
              <Controller
                name="startDate"
                control={control}
                rules={{ required: !isAssignonly ? "Start Date is required" : false }}
                render={({ field: { value, onChange } }) => (
                  <Datepicker
                    label="Start Date"
                    required={!isAssignonly ? true : false}
                    minDate={editData?.newDropStartDate ? undefined : new Date()}
                    value={value}
                    onChange={onChange}
                    error={errors.startDate?.message}
                  />
                )}
              />
              <Controller
                name="startTime"
                rules={{ required: !isAssignonly ? "Start Time is required" : false }}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <SelectBox
                    label="Start Time"
                    value={value}
                    onChange={onChange}
                    placeholder="Select Time"
                    options={timeOptions}
                    required={!isAssignonly ? true : false}
                    error={errors.startTime?.message as any}
                  />
                )}
              />              
            </div>
            <div className={`grid grid-cols-2 gap-2 relative ${isAssignonly ? `disabled-x` : ``}`} style={{ marginTop: -22 }}>
              <Controller
                name="endDate"
                control={control}
                rules={{ required: !isAssignonly ? "End Date is required" : false }}
                render={({ field: { value, onChange } }) => (
                  <Datepicker
                    label="End Date"
                    minDate={editData?.newDropStartDate ? new Date(editData.newDropStartDate) : (watch("startDate") || new Date())}
                    required={!isAssignonly ? true : false}
                    value={value}
                    onChange={onChange}
                    error={errors.endDate?.message}
                  />
                )}
              />
              <Controller
                name="endTime"
                rules={{ required: !isAssignonly ? "End Time is required" : false }}
                control={control}
                render={({ field: { value, onChange } }) => (
                  <SelectBox
                    label="End Time"
                    value={value}
                    onChange={onChange}
                    placeholder="Select Time"
                    options={timeOptions}
                    required={!isAssignonly ? true : false}
                    error={errors.endTime?.message as any}
                  />
                )}
              />
            </div>
            <Controller
              name={ `Notes` }
              //rules={{ required: "Status Note is required" }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <Teaxtarea
                  label="Status Note"
                  value={value}
                  onChange={onChange}
                  //required
                  placeholder="Status Note"
                  className={ `!mt-1` }
                  error={errors.Notes?.message as any}
                />
              )}
            />
          </div>

        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-5 pb-1 border-t" style={{ borderTopColor: `#50575B` }}>
          <Button type="submit" customstyle={{ background: `#2D6A32`, width: 120, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>Save</Button>
          <Button type="button" theme="secondary" onClick={() => {
            formReset();
            onCancel();
          }} customstyle={{ width: 110, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>
            Cancel
          </Button>
          {/* disabled={selectedAssets.length == 0 ? true : false} */}
        </div>
      </form>
    </div>
  );
};

export default ScheduleModalWorkOrder;